import { render, staticRenderFns } from "./DialogLoad.vue?vue&type=template&id=7c80fe65&scoped=true&"
import script from "./DialogLoad.vue?vue&type=script&lang=ts&"
export * from "./DialogLoad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c80fe65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7c80fe65', component.options)
    } else {
      api.reload('7c80fe65', component.options)
    }
    module.hot.accept("./DialogLoad.vue?vue&type=template&id=7c80fe65&scoped=true&", function () {
      api.rerender('7c80fe65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Importar/Conversor/DialogLoad.vue"
export default component.exports